module.exports = __webpack_public_path__ + "img/logo.bb59c573.png";